module.exports = __webpack_public_path__ + "static/media/all-events-blue.a592d102.svg";